module.exports = __webpack_public_path__ + "assets/img/wine-varietal.79b23da3.svg";